<div class="border px-4 h-10 flex items-center justify-between rounded-xl">
  <div class="flex items-center justify-center">
    <img src="assets/icons/circle_check.svg" alt="tick" class="h-4 w-4" />
    <p class="text-sm font-normal ml-2">{{ file?.name }}</p>
  </div>
  <div role="button" (click)="handleOnDelete(file?.id)">
    <img src="assets/icons/cross.svg" alt="tick" class="h-2 w-2 cursor-pointer" />
  </div>
</div>
